import {
    DXFParserSnippet,
    Identity
} from '../shared/parserGenerator';
import isMatched from '../shared/isMatched';

const CommonTableEntryParserSnippets: DXFParserSnippet[] = [
    {
        code: 100,
        name: 'subclassMarker',
        parser: Identity,
    },
    {
        code: 330,
        name: 'ownerObjectId',
        parser: Identity,
    },
    {
        code: 102,
        parser(curr, scanner) {
            let current = curr;
            while (!isMatched(current, 0, 'EOF') && !isMatched(current, 102, '}')) {
                current = scanner.next();
            }
        },
    },
    {
        // DIMSTYLE만 예외적으로 미적용
        code: 5,
        name: 'handle',
        parser: Identity,
    },
];

export default CommonTableEntryParserSnippets;
